
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItemIcon, ListItemText, Menu, Stack,
    Tooltip
} from "@mui/material";

// App Imports

import {
    deleteInterest, interestSearch
} from "./InterestClient";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeInterest} from "./interestSlice";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import InterestDrawer from "./InterestDrawer";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import Button from "@mui/material/Button";
import {changeUploadFile} from "../../CommonComponents/UploadFile/uploadFileSlice";
import UploadFileDrawer from "../../CommonComponents/UploadFile/UploadFileDrawer";
import SearchIcon from "@mui/icons-material/Search";
import InterestSearch from "./InterestSearch";
import AddFiltersExportToolbar from "../../CommonComponents/AddFiltersExportToolbar";
import {UsageGridColumns} from "../Usage/UsageGridColumns";
import {changeUsage} from "../Usage/usageSlice";
import {InterestGridColumns} from "./InterestGridColumns";
import {changeExternalData} from "../externalDataSlice";
import NoSearchCriteriaSnackbar from "../../CommonComponents/NoSearchCriteriaSnackbar";
import InterestInfoDialogue from "./Info/InterestInfoDialogue";

// main function
export default function InterestGrid() {

    // ****************** BEGIN STATES ****************************

    const [interests, setInterests] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showSearch, setShowSearch] = useState(false);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const [interestInfoOpen, setInterestInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorInterestId = useSelector((state) => state.interestSlc.value.id);
    // const selectorInterestMcode = useSelector((state) => state.interestSlc.value.mcode);
    // const selectorInterestName = useSelector((state) => state.interestSlc.value.name);
    // const selectorInterestDescription = useSelector((state) => state.interestSlc.value.description);
    // const selectorInterestCategory = useSelector((state) => state.interestSlc.value.category);
    const selectorDrawerState = useSelector((state) => state.interestSlc.value.interestDrawerState);
    const selectorUploadFileDrawerState = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerState);

    const selectorIdFrom = useSelector((state) => state.interestSearchSlc.value.idFrom);
    const selectorIdTo = useSelector((state) => state.interestSearchSlc.value.idTo);
    const selectorExternalIdFrom = useSelector((state) => state.interestSearchSlc.value.externalIdFrom);
    const selectorExternalIdTo = useSelector((state) => state.interestSearchSlc.value.externalIdTo);
    const selectorRateDateFrom = useSelector((state) => state.interestSearchSlc.value.rateDateFrom);
    const selectorRateDateTo = useSelector((state) => state.interestSearchSlc.value.rateDateTo);
       const selectorRate = useSelector((state) => state.interestSearchSlc.value.rate);
    const selectorSource = useSelector((state) => state.interestSearchSlc.value.source);
    const selectorEffectiveDate = useSelector((state) => state.interestSearchSlc.value.effectiveDate);
    const selectorExpiredOn = useSelector((state) => state.interestSearchSlc.value.expiredOn);
    const selectorIsActive = useSelector((state) => state.interestSearchSlc.value.isActive);


    const selectedId = useSelector((state) => state.interestSlc.value.id);

    const dispatchData = useDispatch();

    const selectorInterestGridRefresh = useSelector((state) => state.interestSlc.value.interestGridRefresh);

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************
    //
    // const fetchInterests = () =>{
    //     if(
    //         selectorIdFrom !== null ||
    //         selectorIdTo !== null ||
    //         selectorExternalIdFrom !== null ||
    //         selectorExternalIdTo !== null ||
    //         selectorRateDateFrom !== null ||
    //         selectorRateDateTo !== null ||
    //         selectorIsActive !== null ||
    //         selectorSource !== null
    //     )
    //     {
    //         {
    //             interestSearch(
    //                 selectorIdFrom,
    //                 selectorIdTo,
    //                 selectorExternalIdFrom,
    //                 selectorExternalIdTo,
    //                 selectorRateDateFrom,
    //                 selectorRateDateTo,
    //                 selectorSource,
    //                 selectorIsActive
    //             )

    //                 .then(data => {
    //                         console.log(data);
    //                         setInterests(data);
    //                     }
    //                 )
    //         }
    //     }
    //     else{console.log("search triggered, nothing to search.")}}

    const fetchInterests = () => {

        const request = {

            idFrom: selectorIdFrom,

            idTo: selectorIdTo,

            externalIdFrom: selectorExternalIdFrom,

            externalIdTo: selectorExternalIdTo,

            rateDateFrom: selectorRateDateFrom,

            rateDateTo: selectorRateDateTo,

            source: selectorSource,

            isActive: selectorIsActive
        };

        console.log("request data");
        console.log(
            JSON.stringify(request, null, 2)
        );

        const hasSearchCriteria = Object.values(request).some(
            value =>
                value !== null &&
                value !== undefined &&
                value !== ''
        );

        if (hasSearchCriteria) {

            dispatchData(changeExternalData({ submitting: true }));

            interestSearch(request)


                .then(data => {

                    console.log(data);

                    setInterests(data);

                    if (!data || data.length === 0) {
                        console.log("no matching records found");
                        dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "info", snackbarMessage: "No matching records found" }));
                    }

                })

                .catch(err => {

                    console.error(err);

                })

                .finally(() => {

                    // setSubmitting(false);
                    dispatchData(changeExternalData({ submitting: false }));
                });

        } else {

            console.log(
                "search triggered, nothing to search."
            );
            dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "warning", snackbarMessage: "No search criteria provided" }));
        }
    };

    // ****************** END FETCH ****************************

    const renderInterests = interests => {
        if (interests.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }
    //
    // useEffect(() => {
    //     fetchInterests();
    //     dispatchData(changeInterest({interestGridRefresh: false}));
    // }, [useSelector((state) => state.interestSlc.value.interestGridRefresh)===true]);



    useEffect(() => {

        if (selectorInterestGridRefresh) {

            fetchInterests();

            dispatchData(changeInterest({
                interestGridRefresh: false
            }));
        }

    }, [selectorInterestGridRefresh]);

    function handleSearch(){
        setShowSearch(!showSearch)
    }

    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeInterest({id: null, externalId: null,
            rateDate: null,
            rate: null, source: null, effectiveDate: null, expiredOn: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            interestDrawerState: true, interestDrawerMode: "Add"}));
    };


    const handleUploadFileDrawer = () => {
        console.log("upload file drawer state changed");
        dispatchData(changeUploadFile({uploadFileDrawerState: true,
            uploadFileDrawerMode: "Interest"}));
    };

    const removeInterest = () => {
        deleteInterest(selectorInterestId).then(() => {
            // successNotification("Data Point Attribute deleted", `Data Point Attribute with id ${selectorInterestId} was deleted`);
            setDeleteOpen(false);
            dispatchData(changeInterest({interestGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    };

    function DeleteConfirmationDialog() {
        // const [open, setOpen] = useState(false);

        const handleClickOpen = () => {
            setDeleteOpen(true);
        };

        const handleClose = () => {
            setDeleteOpen(false);
        };


        const handleDelete = () => {
            // Place your delete logic here
            deleteInterest(selectedId).then(() => {
                // successNotification("Data Point Attribute deleted", `Data Point Attribute with id ${selectorFinancialId} was deleted`);
                setDeleteOpen(false);
                dispatchData(changeInterest({interestGridRefresh: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            })
            console.log('Item deleted');
        };






        return (
            <Dialog
                open={deleteOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent', // makes backdrop transparent
                        boxShadow: '0 0 10px 5px rgba(0, 0, 0, 0.5)' // custom shadow box effect
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this item? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };



    const gridClear = () => {

        setInterests([]);
    }


    // ****************** END CRUD ***********************************


    const handleInterestInfo = () => {
        setInterestInfoOpen(true);
    };

    const handleCloseInterestInfo = () => {
        setInterestInfoOpen(false);
    };




    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (interests) => {

        console.log('Interest data from clicked row');
        console.log(interests);
        dispatchData(changeInterest({id: interests.id, externalId: interests.externalId,
            rateDate: interests.rateDate,
            rate: interests.rate, source: interests.source,
            effectiveDate: interests.effectiveDate,
            expiredOn: interests.expiredOn,
            createdOn: interests.createdOn,createdBy:interests.createdBy,
            lastModifiedOn:interests.lastModifiedOn,lastModifiedBy:interests.lastModifiedBy}));
    };


    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 80, pt: 1, pl: 3}}>
                <Stack direction={"horizontal"}>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                    <h3
                        style={{cursor:'pointer'}}   onClick={() => handleInterestInfo()}
                    >Interest Rates</h3>
                    </Tooltip>
                    {/*<SearchIcon*/}
                    {/*    sx={{pt: 2, ml: 2}}*/}
                    {/*    color={'primary'}*/}
                    {/*    onClick={handleSearch}*/}
                    {/*/>*/}
                        <InterestInfoDialogue
                            open={interestInfoOpen}
                            onClose={handleCloseInterestInfo}
                        />
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            color="primary"
                            size="large"               // large icon & hit area
                            onClick={handleSearch}
                            sx={{ ml: 2 }}             // any spacing you want
                        >
                            <SearchIcon fontSize="inherit" />
                        </IconButton>
                    </Box>
                    <Button sx={{pt: 1, ml: 3}}
                            onClick={handleUploadFileDrawer}
                    >Upload</Button>
                </Stack>
            </Box>
            {showSearch && <InterestSearch
                gridClear = {gridClear}
            />}
            {selectorUploadFileDrawerState && <UploadFileDrawer/>}
            {selectorDrawerState && <InterestDrawer
            />}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Interests"}
                rows={interests}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={InterestGridColumns({
                    hideActions,
                    onEdit: () => dispatchData(changeInterest({ interestDrawerState: true, interestDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeInterest({ interestDrawerState: true, interestDrawerMode: "Clone" })),
                    onDelete: removeInterest
                })}
                onRowClick = {(interests)=>handleClickedRow(interests.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={interest => interest.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
            <NoSearchCriteriaSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}



